//Importation des components
//import "./components/index";

//Importation des feuilles de styles
import './assets/styles/styles.scss';


//Ponyfill pour les CSS du thème seulement (assure le bon fonctionnement dans les vieux navigateurs)
import cssVars from "css-vars-ponyfill";
cssVars({
    include: "style, link#main-style-css"
});